import { mapActions, mapGetters, mapState } from 'vuex';
import { VRuntimeShell } from '@grupoa/components';
import GetStudentTypeMixin from '@/mixins/student-type';
import { ABtn } from '@maisaedu/ui-components-a-btn';
import NoticeEditPreviewContent from '@/components/comunication/modals/notice-edition/preview-content';

const NOTICE_TYPES = {
  HTML   : 1,
  SURVEY : 2
};

export default {
  mixins     : [GetStudentTypeMixin],
  components : {
    VRuntimeShell,
    ABtn,
    NoticeEditPreviewContent
  },
  async mounted() {
    if (this.isAuthenticated) {
      await this.checkForHighlightedNotice();
    }
  },
  data() {
    return {
      NOTICE_TYPES,
      isOpen              : false,
      notice              : null,
      isCheckingForSurvey : false,
      hasFinishedSurvey   : false,
      applicationBaseUrl  : process.env.APPLICATION_ROUTE_BASE
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: '_core/auth/isAuthenticated'
    }),
    ...mapState({
      iesDefaultColor : (state) => state._core.application.themes.light.primary,
      noticeDisplayed : (state) => state.plataforma.notice.noticeDisplayed,
      iesAlias        : (state) => state._core.tenant.iesAlias,
      user            : (state) => state._core.user,
      userContext     : (state) => state.plataforma.user,
      userRole        : (state) => state._core.auth.currentRole.role.alias
    })
  },
  beforeDestroy: function() {
    this.$nuxt.$off('highlightNoticeActionTaken');
  },
  methods: {
    ...mapActions({
      getNoticeByRole      : 'plataforma/notice/getNoticeByRole',
      sendAgreedNotice     : 'plataforma/notice/sendAgreedNotice',
      getHighlightedNotice : 'plataforma/notice/getHighlightedNotice'
    }),
    async checkForHighlightedNotice() {
      if (this.userRole === 'student' || this.userContext?.isStudent) {
        const data = await this.getHighlightedNotice()
          .catch(() => this.$toast.error(this.$t('notice.errorLoading'))
          );
        const notice = data?.modalConfig;
        if (notice && Object.keys(notice).length > 0) {
          this.$nuxt.$emit('openHighlightNoticeModal', { notice });
        } else {
          await this.checkForSurvey();
        }
        this.$nuxt.$on('highlightNoticeActionTaken', this.handleHighlightNoticeClosed);
      }
    },
    handleHighlightNoticeClosed() {
      this.checkForSurvey();
    },
    async checkForSurvey() {
      if (this.isCheckingForSurvey || this.noticeDisplayed) {
        return;
      }

      this.isCheckingForSurvey = true;

      this.getNoticeByRole()
        .then(response => {
          this.notice = response || null;
          if (this.notice?.noticeTypeId === NOTICE_TYPES.SURVEY) {
            this.setupTypeformScript();
          }
          this.isOpen = !!this.notice;
        });
      this.isCheckingForSurvey = false;
    },
    handleClickCloseButton() {
      if (this.hasFinishedSurvey) {
        this.isOpen = false;
        this.notice = null;
        return;
      }

      if (this.notice?.hasDeclineOption || this.notice?.noticeTypeId === NOTICE_TYPES.HTML) {
        this.sendAgreedNotice({ hasAgreed: false, noticeId: this.notice.id });
        this.isOpen = false;
        this.notice = null;
        return;
      }

      this.$dialog.show({
        type                 : 'warning',
        title                : this.$t('notice.mandatorySurveyMessageTitle'),
        message              : this.$t('notice.mandatorySurveyMessageContent'),
        showCancelButton     : false,
        confirmButtonVariant : 'text'
      });
    },
    handleSurveySubmit() {
      this.hasFinishedSurvey = true;
      this.sendAgreedNotice({ hasAgreed: true, noticeId: this.notice.id });
    },
    setupTypeformScript() {
      if (document.body.querySelector('[data-typeform-script]')) {
        return;
      }
      const typeformScript = document.createElement('script');
      typeformScript.dataset.typeformScript = true;
      typeformScript.src = '//embed.typeform.com/next/embed.js';
      typeformScript.type = 'text/javascript';
      document.body.appendChild(typeformScript);
      window.submitTypeForm = () => {
        this.handleSurveySubmit();
      };
    }
  }
};